export default __webpack_public_path__ + "static/media/center4.b8a5de2f.jpg";